import { OWNER_FRANCHISE_NAME } from '../constants/ownerScope';

/**
 * 担当拠点 scope for the FCオーナー portal.
 *
 * Fixture-level: the real list comes from `user_clinic_assignments` and the KPI
 * from 施術予定 / 実施 / 返戻 aggregates. Screens and the shell both read through
 * here, so the swap to an API is one file.
 */

export interface OwnerClinic {
  /** 拠点名, as shown in the list's 拠点 column. */
  name: string;
  /** 拠点コード shown next to the name in the filter. */
  code: string;
}

const OWNER_CLINICS: OwnerClinic[] = [
  { name: 'さくらST', code: '12-1' },
  { name: 'ひまわりST', code: '13-2' },
  { name: 'すみれST', code: '13-3' },
];

/** 拠点 the signed-in owner manages. */
export function getOwnerClinics(): OwnerClinic[] {
  return OWNER_CLINICS;
}

/** `はなみずき加盟店 配下3拠点` — the scope line in the list footer. */
export function getOwnerScopeLabel(): string {
  return `${OWNER_FRANCHISE_NAME} 配下${OWNER_CLINICS.length}拠点`;
}

export interface ClinicKpi {
  /** 施術予定 */
  planned: number;
  /** 施術実施 */
  done: number;
  /** 返戻 */
  returned: number;
}

/** Per-拠点 KPI behind the system tiles (R-04 right zone). */
const CLINIC_KPI: Record<string, ClinicKpi> = {
  さくらST: { planned: 18, done: 13, returned: 1 },
  ひまわりST: { planned: 16, done: 12, returned: 1 },
  すみれST: { planned: 14, done: 10, returned: 0 },
};

/**
 * R-04: the system tiles are counted over the **selected** 拠点, so they must be
 * recomputed whenever the 拠点フィルター changes — they are not a static total.
 */
export function aggregateClinicKpi(clinicNames: string[]): ClinicKpi {
  return clinicNames.reduce<ClinicKpi>(
    (total, name) => {
      const kpi = CLINIC_KPI[name];
      if (!kpi) return total;
      return {
        planned: total.planned + kpi.planned,
        done: total.done + kpi.done,
        returned: total.returned + kpi.returned,
      };
    },
    { planned: 0, done: 0, returned: 0 }
  );
}
